export const strings: Record<string, string> = {
  dayLabel: 'Day',
  dayPlaceholder: 'DD',
  monthLabel: 'Month',
  monthPlaceholder: 'MM',
  yearLabel: 'Year',
  yearPlaceholder: 'YYYY',
}

export type DateOfBirthFieldStrings = typeof strings
